export const ContactsIcon = () => {
  return (
    <svg
      height="31.991"
      viewBox="0 0 31.197 31.991"
      width="31.197"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g data-name="Grupo 4052" id="Grupo_4052" transform="translate(0 0)">
        <g data-name="Grupo 3249" id="Grupo_3249" transform="translate(0 0)">
          <rect
            data-name="Rectángulo 2394"
            fill="#004dbc"
            height="31.991"
            id="Rectángulo_2394"
            rx="5"
            width="31.197"
          />
        </g>
        <g
          data-name="Icon ionic-md-contacts"
          id="Icon_ionic-md-contacts"
          transform="translate(4.417 6)"
        >
          <g data-name="Grupo 3444" id="Grupo_3444" transform="translate(0 2.796)">
            <path
              d="M12.593,24.183a6.1,6.1,0,0,1-6.015,0c-2.354.718-3.8,3.1-4.328,5.194H16.922C16.39,27.281,14.948,24.9,12.593,24.183Z"
              data-name="Trazado 3196"
              fill="#fff"
              id="Trazado_3196"
              transform="translate(-2.25 -13.006)"
            />
            <path
              d="M10.423,8.44a5.284,5.284,0,1,0,5.286,5.284A5.285,5.285,0,0,0,10.423,8.44Zm0,9.309a4.084,4.084,0,0,1-3.694-2.522h7.388A4.084,4.084,0,0,1,10.423,17.749Z"
              data-name="Trazado 3197"
              fill="#fff"
              id="Trazado_3197"
              transform="translate(-3.088 -8.44)"
            />
          </g>
          <g data-name="Grupo 3445" id="Grupo_3445" transform="translate(10.573)">
            <path
              d="M21.465,25.041h7.857a6.532,6.532,0,0,0-4.328-4.8,6.108,6.108,0,0,1-5.113.418,7,7,0,0,1-1.4,1.742A6.778,6.778,0,0,1,21.465,25.041Z"
              data-name="Trazado 3198"
              fill="#fff"
              id="Trazado_3198"
              transform="translate(-17.532 -9.068)"
            />
            <path
              d="M20.274,11.289h5.016A4.074,4.074,0,0,1,21.6,13.8a3.8,3.8,0,0,1-1.267-.225A6.41,6.41,0,0,1,20,14.829a5.287,5.287,0,1,0-2.863-7.876A6.531,6.531,0,0,1,20.274,11.289Z"
              data-name="Trazado 3199"
              fill="#fff"
              id="Trazado_3199"
              transform="translate(-17.142 -4.502)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
